export const UPDATE_INFERENCE_STATUS = 'UPDATE_INFERENCE_STATUS';
export const UPDATE_DEVICE_INFO = 'UPDATE_DEVICE_INFO';
export const UPDATE_CONFIG_OPTIONS = 'UPDATE_CONFIG_OPTIONS';
